import { AuthenticatedImage } from '@components/AuthenticatedImage/AuthenticatedImage';
import { LibraryCardPlaceholder } from '@components/LibraryThumbnail/LibraryCardPlaceholder';
import { useLibraryThumbnail } from '@components/LibraryThumbnail/useLibraryThumbnail';
import { LibraryStore } from '@stores/Library/Library';
import css from './LibraryIcon.module.scss';

export const LibraryIcon = ({
  library,
  zIndex,
  marginLeft,
  style,
}: {
  zIndex: number;
  marginLeft: number;
  library: LibraryStore & { data: NonNullable<LibraryStore['data']> };
  style?: React.CSSProperties;
}) => {
  const { url, token, onError } = useLibraryThumbnail(library);

  return (
    <>
      {url ? (
        <AuthenticatedImage
          className={css.libraryIcon}
          src={url}
          token={token}
          onError={onError}
          style={{
            zIndex: zIndex,
            marginLeft: marginLeft,
            ...style,
          }}
        />
      ) : (
        <div
          className={css.libraryIcon}
          style={{
            zIndex: zIndex,
            marginLeft: marginLeft,
            ...style,
          }}
        >
          <LibraryCardPlaceholder seed={library.libraryId} />
        </div>
      )}
    </>
  );
};
